module.exports = "/img/calculator-banner-2.63678157.png";